import { render, staticRenderFns } from "./free.vue?vue&type=template&id=11f4aa9d&"
import script from "./free.vue?vue&type=script&lang=js&"
export * from "./free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,BlockImage: require('/home/smiley/3df/components/Block/BlockImage/BlockImage.vue').default,CardProfile: require('/home/smiley/3df/components/Card/CardProfile/CardProfile.vue').default,Banner: require('/home/smiley/3df/components/Banner/Banner.vue').default,CardTestimonial: require('/home/smiley/3df/components/Card/CardTestimonial/CardTestimonial.vue').default,Gallery: require('/home/smiley/3df/components/Gallery/Gallery.vue').default,SectionRegister: require('/home/smiley/3df/components/Section/SectionRegister/SectionRegister.vue').default})
